import { render, staticRenderFns } from "./application-card-header.vue?vue&type=template&id=72b6fce5"
import script from "./application-card-header.vue?vue&type=script&lang=js"
export * from "./application-card-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports